import * as React from 'react';

import { withOktaAuth } from '@okta/okta-react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { accountActions } from '../../actions/account.actions';
import { OktaProps } from './Okta/types';

type MappedState = ReturnType<ReturnType<typeof mapStateToPropsFactory>>;
const mapStateToPropsFactory = (initialState, ownProps) => {
  return (state: AppState, ownProps) => {
    const { account } = state;
    return {
      account,
    };
  };
};
type MappedDispatch = ReturnType<ReturnType<typeof mapDispatchToPropsFactory>>;
const mapDispatchToPropsFactory = (dispatch, ownProps) => {
  return (dispatch: ThunkDispatch, ownProps) => {
    return {
      logout: async () => {
        try {
          await dispatch(accountActions.logout());
        } catch (error) {
          console.error(error);
        }
      },
    };
  };
};

type Props = MappedState & MappedDispatch & OktaProps;
const Logout = compose<Props, {}>(
  withOktaAuth,
  connect(mapStateToPropsFactory, mapDispatchToPropsFactory)
)(
  class extends React.Component<Props, {}> {
    public componentDidMount() {
      if (this.props.account.authorized) {
        if (this.props.oktaAuth && this.props.authState?.accessToken) {
          this.props.oktaAuth.session.close();
          this.props.oktaAuth.signOut();
        }
        this.props.logout();
      }
    }

    public render() {
      return null;
    }
  }
);

export default Logout;
